import { DateTime } from 'luxon'
import { createContext, FC, ReactNode } from 'react'

export type WeekStartsOn = 'sunday' | 'monday'

/**
 * The dated week currently rendered on screen. Leaf components read this so
 * their query windows line up with the columns they are rendered beside,
 * regardless of whether the week was seeded from the signed-in user (admin
 * grids) or the user being viewed (the time logger).
 */
export interface WeekScope {
  end: DateTime
  range: DateTime[]
  start: DateTime
  weekStartsOn: WeekStartsOn
}

export const WeekScopeContext = createContext<WeekScope | null>(null)

export const WeekScopeProvider: FC<{
  children: ReactNode
  value: WeekScope
}> = ({ children, value }) => (
  <WeekScopeContext.Provider value={value}>
    {children}
  </WeekScopeContext.Provider>
)
